import './index.css';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Form, Modal, Tab, Tabs } from 'react-bootstrap';
import { IoArrowBackOutline, IoCreateOutline, IoDocumentTextOutline, IoTrashOutline } from 'react-icons/io5';
import { MdAdd } from 'react-icons/md';
import { v4 as uuidv4 } from 'uuid';
import { db } from '../../../../firebase';
import { collection, doc, onSnapshot, orderBy, query, setDoc } from 'firebase/firestore';
import OutletHead from '../../../../components/common/outlet-head';
import Units from '../../../../components/forms/property/units';
import UnitDetails from './units';
import { toast } from 'react-toastify';
import PaymentPlans from './payment-plans';
import PaymentForm from '../../../../components/forms/property/payment-plans/payment';
import PlanForm from '../../../../components/forms/property/payment-plans/plan';
import EditProperty from '../../../../components/modals/property/edit-property';
import { useAuth } from '../../../../context/AuthContext';

const Details = () => {

  const location = useLocation();
  let { state } = location;
  let navigate = useNavigate();

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [item, setItem] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [planID, setPlanID] = useState(null);
  const [paymentPlanData, setPaymentPlanData] = useState(null);
  const [planData, setPlanData] = useState(null);
  const [towers, setTowers] = useState(null);
  const [towerData, setTowerData] = useState({
    numTower: '',
    towerNames: []
  });
  const [towerNames, setTowerNames] = useState([]);
  const [towerKey, setTowerKey] = useState(0);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [editPropertyModalShow, setEditPropertyModalShow] = useState(false);
  const [showTowerModal, setShowTowerModal] = useState(false);
  const [showPaymentPlanModal, setShowPaymentPlanModal] = useState(false);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [showUnitModal, setShowUnitModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [inputError, setInputError] = useState();

  const handleEditPropertyModalClose = () => setEditPropertyModalShow(false);

  const handleCloseUnit = () => {
    setShowUnitModal(false);
    setSelectedUnit(null);
  }
  const handleShowUnit = () => setShowUnitModal(true);

  const handleCloseTowerModal = () => setShowTowerModal(false);
  const handleShowTowerModal = () => setShowTowerModal(true);

  const handleClosePlanModal = () => setShowPlanModal(false);
  const handleShowPlanModal = () => setShowPlanModal(true);

  const handleClosePaymentPlanModal = () => setShowPaymentPlanModal(false);
  const handleShowPaymentPlanModal = () => setShowPaymentPlanModal(true);

  const handleClose = () => setShowDelete(false);
  const handleShow = () => setShowDelete(true);

  function getPropertyItem(id) {
    const unsubscribe = onSnapshot(doc(db, "Businesses", bid, "Properties", id), (doc) => {
      setItem({ id: id, ...doc.data() });
    });

    return () => unsubscribe;
  }

  async function getAllTowers(propID) {
    const q = query(collection(db, "Businesses", bid, "Properties", propID, "Towers"), orderBy('name'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setTowers(tempData);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    if (state && state.items) {
      setItem(state.items);
      getAllTowers(state.items.id);
    }

    return () => setIsLoading(false);
  }, [location]);

  // async function handleDeleteItem() {
  //   setIsDeleting(true);
  //   if (!units) {
  //     await deleteDoc(doc(db, "Properties", item.id));
  //     navigate('/admin/properties');
  //   } else {
  //     toast.error(`Unable to delete!`);
  //     handleClose();
  //   }

  //   setIsDeleting(false);
  // }

  async function handleSavePlans(propID, towerID, data) {
    if (data) {
      data.forEach(async ele => {
        let uuid = uuidv4();

        try {
          await setDoc(doc(db, "Businesses", bid, "Properties", propID, "PaymentPlans", uuid), {
            serialNumber: ele.serialNumber,
            addedOn: new Date(),
            name: ele.name,
            towerID: towerID,
            updatedOn: new Date()
          });
          toast.success(ele.name, ' Created');
        } catch (error) {
          toast.danger(`Something went wrong!`);
          console.log('Adding Plans [Error] : ', error);
        }
      });
      handleClosePlanModal(false);
      setPlanData(null);
    } else {
      toast.error('Something went wrong!');
    }
  }

  async function handleSavePaymentPlan(propID, towerID, planID, data) {
    console.log(propID, towerID, planID, data);

    if (data) {
      data.forEach(async ele => {
        let uuid = uuidv4();

        try {
          await setDoc(doc(db, "Businesses", bid, "Properties", propID, "PaymentPlans", planID, "Payments", uuid), {
            serialNumber: ele.serialNumber,
            addedOn: new Date(),
            name: ele.name,
            value: ele.value,
            other: ele.other,
            isCompleted: ele.isCompleted,
            valueType: ele.valueType,
            description: ele.description,
            updatedOn: new Date()
          });
        } catch (error) {
          console.log('Adding Payment [Error] : ', error);
        }
      });
      toast.success('Payments, Created');
      handleClosePaymentPlanModal(false);
      setPaymentPlanData(null);
    } else {
      toast.error('Something went wrong!');
    }
  }

  async function handleAddTowers() {
    if (towerData && !towerData.numTower) {
      setInputError({ numTower: 'This field is mandatory.' });
    } else if (towerData && !towerData.towerNames && towerData.towerNames.length === 0) {
      setInputError({ towerNames: 'This field is mandatory.' });
    } else {
      setIsLoading(true);
      const propID = state.items.id;
      towerData && towerData.towerNames.forEach(async (obj) => {
        try {
          await setDoc(doc(db, "Businesses", bid, "Properties", propID, "Towers", obj.id), {
            addedOn: new Date(),
            name: obj.name,
            number: obj.number,
            numFloors: obj.numFloors,
            totalUnitCount: obj.totalUnitCount,
            updatedOn: new Date()
          });

          setShowTowerModal(false);
          setTowerData({
            numTower: '',
            towerNames: []
          });
          setIsLoading(false);
        } catch (error) {
          console.log('Adding Towers [Error] : ', error);
          toast.danger(`Something went wrong!`);
          setIsLoading(false);
        }
      });

      toast.success(`Successfully, Tower Added.`);
    }
  }

  const checkDuplicateChange = (item, event) => {
    var tempData = [...towerData.towerNames];
    tempData[item] = { id: uuidv4(), number: item + 1, name: event.target.value };
    setTowerData({ ...towerData, towerNames: tempData });
    var towerNameArr = tempData && tempData.map((item) => item.name);

    var duplicateResponse = towerNameArr.some((item, idx) => {
      return towerNameArr.indexOf(item) !== idx;
    });

    setIsDuplicate(duplicateResponse);
  }

  return (
    <section className='section'>
      <div className='row'>
        <div className='col-md-12 col-12'>
          <OutletHead
            left={
              <div className='d-flex align-items-center'>
                <Button
                  variant='light'
                  size='sm'
                  className='p-2 me-3 rounded-circle'
                  onClick={() => navigate(-1)}
                >
                  <IoArrowBackOutline size={24} />
                </Button>
                <h5 className='mb-0 fw-600'>{item && item.name}</h5>
              </div>
            }
            right={
              <div className='d-flex align-items-center justify-content-end'>
                <Button
                  variant="outline-primary"
                  type="button"
                  className='py-2 px-4 me-3'
                >
                  <IoDocumentTextOutline size={20} />
                  <span className='ps-2'>Export</span>
                </Button>
                <Button
                  variant="outline-success"
                  type="button"
                  className='py-2 px-3 me-3'
                  onClick={() => setEditPropertyModalShow(true)}
                >
                  <IoCreateOutline size={20} />
                  <span className='ps-2'>Edit</span>
                </Button>
                <Button
                  variant="outline-danger"
                  type="button"
                  className='py-2 px-3'
                  onClick={handleShow}
                >
                  <IoTrashOutline size={20} />
                  <span className='ps-2'>Delete</span>
                </Button>
              </div>
            }
          />
          <div className='inner-wrapper p-3 border-top'>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-12'>
                <div className='overflow-hidden'>
                  <div className='bg-primary-light rounded mb-2 d-flex justify-content-between'>
                    <h5 className='mb-0 py-3 px-3'>Basic Details</h5>
                  </div>
                  <div className='row'>
                    <div className='col-md-4 col-12 px-3'>
                      <div className="mb-3 px-3">
                        <span className='form-label'>
                          Project Name
                        </span>
                        <div>{item && item.name}</div>
                      </div>
                    </div>
                    <div className='col-md-4 col-12 px-3'>
                      <div className="mb-3 px-3">
                        <span className='form-label'>
                          Property Type
                        </span>
                        {
                          item && item.type ?
                            <div>{item && item.type}</div>
                            :
                            <div>--</div>
                        }
                      </div>
                    </div>
                    <div className='col-md-4 col-12 px-3'>
                      <div className="mb-3 px-3">
                        <span className='form-label'>
                          Unit Measure
                        </span>
                        {
                          item && item.unitMeasure ?
                            <div>{item && item.unitMeasure}</div>
                            :
                            <div>--</div>
                        }
                      </div>
                    </div>
                    {
                      item && item.type === 'Land' ?
                        <div className='col-md-4 col-12 px-3'>
                          <div className="mb-3 px-3">
                            <span className='form-label'>
                              Total Area
                            </span>
                            {
                              item && item.totalArea ?
                                <div>{item && item.totalArea} {item && item.unitMeasure}</div>
                                :
                                <div>--</div>
                            }
                          </div>
                        </div>
                        :
                        null
                    }
                    <div className='col-md-4 col-12 px-3'>
                      <div className="mb-3 px-3">
                        <span className='form-label'>
                          Address
                        </span>
                        <div>
                          {item && item.number ? item.number + ', ' : null}
                          {item && item.locality ? item.locality + ', ' : null}
                        </div>
                      </div>
                    </div>
                    <div className='col-md-4 col-12 px-3'>
                      <div className="mb-3 px-3">
                        <span className='form-label'>
                          City & Pincode
                        </span>
                        <div>
                          {item && item.city ? item.city + ', ' : null}
                          {item && item.pincode}
                        </div>
                      </div>
                    </div>
                    <div className='col-md-4 col-12 px-3'>
                      <div className="mb-3 px-3">
                        <span className='form-label'>
                          State
                        </span>
                        <div>{item && item.state ? item.state : '--'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12'>
                <div className='overflow-hidden mt-3'>
                  <div className='bg-primary-light rounded mb-2 d-flex align-items-center justify-content-between'>
                    <h5 className='mb-0 py-3 px-3'>Towers</h5>
                    {
                      towers && towers.length > 0 ?
                        <Button
                          variant='primary'
                          size='sm'
                          className='m-3 py-2 px-3 border border-primary rounded'
                          onClick={handleShowUnit}
                        >
                          <MdAdd size={18} />
                          <span className='ms-1'>New Unit</span>
                        </Button>
                        :
                        null
                    }
                  </div>
                  {
                    towers && towers.length > 0 ?
                      <Tabs
                        activeKey={towerKey}
                        onSelect={(k) => setTowerKey(k)}
                        className="pb-3 mt-3"
                        variant="pills"
                      >
                        {
                          towers && towers.map((tow, i) => {
                            return (
                              <Tab key={i} eventKey={i} title={<span className='text-capitalize'>{tow && tow.name}</span>}>
                                <div className='row'>
                                  <div className='col-md-7'>
                                    <UnitDetails
                                      handleShowUnit={handleShowUnit}
                                      propertyItems={state.items}
                                      towerID={tow.id}
                                      setSelectedUnit={(unitData) => setSelectedUnit(unitData)}
                                    />
                                  </div>

                                  <div className='col-lg-5 col-md-12 col-12 ps-0'>
                                    <PaymentPlans
                                      propertyItems={state.items}
                                      towerID={tow.id}
                                      handleShowPayment={handleShowPaymentPlanModal}
                                      handleShowPlan={handleShowPlanModal}
                                      setPlanID={setPlanID}
                                      setPaymentPlanData={setPaymentPlanData}
                                    />
                                  </div>
                                </div>
                              </Tab>
                            )
                          })
                        }
                      </Tabs>
                      :
                      <div className='mx-3 mb-3 mt-4'>
                        <Button
                          variant='white'
                          className='w-100 py-5 border-long-dashed rounded border-0 shadow-none'
                          onClick={handleShowTowerModal}
                        >
                          <MdAdd size={20} color={`var(--bs-primary)`} />
                          <span className='ms-1 text-primary'>Create Tower</span>
                        </Button>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT PROPERTY DETAILS */}
      <EditProperty
        items={item}
        editPropertyModalShow={editPropertyModalShow}
        handleEditPropertyModalClose={() => {
          handleEditPropertyModalClose();
          getPropertyItem(item.id)
        }}
      />

      {/* CREATE TOWER MODAL  */}
      <Modal
        show={showTowerModal}
        onHide={() => {
          handleCloseTowerModal();
          setTowerData({
            numTower: '',
            towerNames: []
          });
        }}
        size={towerData && towerData.numTower ? 'lg' : 'md'}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Tower</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-12 col-12'>
              <Form.Group className="mb-3" controlId="numFloors">
                <Form.Label>Number of Tower *</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="0"
                  onFocus={(event) => event.target.select()}
                  onChange={(event) => {
                    setTowerData({ ...towerData, numTower: event.target.value, towerNames: [] });
                    if (event.target.value && event.target.value > 0) {
                      const tempArray = Array.from(Array(Number(event.target.value)).keys());
                      setTowerNames(tempArray);
                    } else {
                      setTowerNames([]);
                    }
                  }}
                  className={inputError && inputError.numTower ? 'border-danger' : null}
                  value={towerData && towerData.numTower}
                  isInvalid={inputError && inputError.numTower}
                />
                <Form.Control.Feedback type="invalid">{inputError && inputError.numTower}</Form.Control.Feedback>
              </Form.Group>
            </div>
          </div>
          {
            towerData && towerData.numTower ?
              <div className='row'>
                <div className='px-3 py-3 bg-primary-light mb-3'>
                  <h6 className='mb-0'>Tower Details</h6>
                </div>
                {
                  towerNames && towerNames.map((item, index) => {
                    return (
                      <div key={index} className='col-md-12'>
                        <div className='row'>
                          <div className='col-md-4'>
                            <Form.Group className="mb-3" controlId="numFloors">
                              <Form.Label>Tower #{item + 1} *</Form.Label>
                              <Form.Control
                                placeholder="Enter Tower Name"
                                onFocus={(event) => event.target.select()}
                                onChange={(event) => checkDuplicateChange(item, event)}
                                className={isDuplicate && isDuplicate ? 'border-danger text-capitalize' : 'text-capitalize'}
                                isInvalid={isDuplicate && isDuplicate}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-md-4'>
                            <Form.Group className="mb-3" controlId="numFloors">
                              <Form.Label>Number of Floors *</Form.Label>
                              <Form.Control
                                type='number'
                                placeholder={`Number of floors`}
                                onFocus={(event) => event.target.select()}
                                onChange={(event) => {
                                  var tempTowerNames = towerData && [...towerData.towerNames];
                                  tempTowerNames[index].numFloors = event.target.value;
                                  setTowerData({ ...towerData, towerNames: tempTowerNames });
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-md-4'>
                            <Form.Group className="mb-3" controlId="totalUnitCount">
                              <Form.Label>Total Unit Count (per Floor) *</Form.Label>
                              <Form.Control
                                type='number'
                                placeholder={`Enter total unit count per floor`}
                                onFocus={(event) => event.target.select()}
                                onChange={(event) => {
                                  var tempTowerNames = towerData && [...towerData.towerNames];
                                  tempTowerNames[index].totalUnitCount = event.target.value;
                                  setTowerData({ ...towerData, towerNames: tempTowerNames });
                                }}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
              :
              null
          }
        </Modal.Body>
        <Modal.Footer className='justify-content-between'>
          <Button
            variant="outline-dark"
            onClick={() => {
              handleCloseTowerModal();
              setTowerData({
                numTower: '',
                towerNames: []
              });
            }}
            className='px-5 py-2 btn-width'
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className='px-5 py-2 btn-width'
            onClick={handleAddTowers}
          >
            Create
          </Button>
        </Modal.Footer>
      </Modal>

      {/* CREATE PLANS FOR PAYMENT PLAN MODAL  */}
      <Modal
        show={showPlanModal}
        onHide={() => {
          handleClosePlanModal();
          setPlanData(null);
        }}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Plan</Modal.Title>
        </Modal.Header>

        <PlanForm
          planData={planData}
          setPlanData={setPlanData}
        />

        <Modal.Footer className='justify-content-between'>
          <Button
            variant="outline-dark"
            onClick={() => {
              handleClosePlanModal();
              setPlanData(null);
            }}
            className='px-5 py-2 btn-width'
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className='px-5 py-2 btn-width'
            onClick={() => handleSavePlans(state.items.id, towers && towers[towerKey].id, planData)}
          >
            Create
          </Button>
        </Modal.Footer>
      </Modal>

      {/* CREATE PAYMENTS FOR PAYMENT PLAN MODAL  */}
      <Modal
        show={showPaymentPlanModal}
        onHide={() => {
          handleClosePaymentPlanModal();
          setPaymentPlanData(null);
        }}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Payments</Modal.Title>
        </Modal.Header>

        <PaymentForm
          paymentPlanData={paymentPlanData}
          setPaymentPlanData={setPaymentPlanData}
        />

        <Modal.Footer className='justify-content-between'>
          <Button
            variant="outline-dark"
            onClick={() => {
              handleClosePaymentPlanModal();
              setPaymentPlanData(null);
            }}
            className='px-5 py-2 btn-width'
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className='px-5 py-2 btn-width'
            onClick={() => handleSavePaymentPlan(state.items.id, towers && towers[towerKey].id, planID, paymentPlanData)}
          >
            Create
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ADD UNIT MODAL  */}
      {
        showUnitModal ?
          <Units
            allTowers={towers}
            tower={towers && towers[towerKey]}
            state={{ ...item, item: selectedUnit }}
            unitMeasure={item && item.unitMeasure}
            showUnitModal={showUnitModal}
            handleCloseUnit={handleCloseUnit}
          />
          :
          null
      }

      <Modal
        show={showDelete}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='mb-0 text-center'>Are you sure, you want to delete?</h5>
        </Modal.Body>
        <Modal.Footer className='justify-content-center'>
          <Button
            variant="outline-dark"
            onClick={handleClose}
            className='px-5 py-2'
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className='px-5 py-2'
            onClick={null}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default Details;
